import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../../providers';

/*
  Generated class for the M2Xv2ServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class M2Xv2ServiceProvider {

  bssURL: String = this.globalServiceProvider.appConfig.bss_api;
  constructor(public http: HttpClient, private globalServiceProvider: GlobalServiceProvider) {
    console.log('Hello M2Xv2ServiceProvider Provider');
  }
  
  async getAttachment(data: any) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      const options: any = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        responseType: 'arraybuffer'
      };
      options.params = {
        postdata: JSON.stringify(data)
      };
      this.http.get<any[]>(`${this.bssURL}/m2x/jobs/jobId/downloadfile/attachmentId`, options).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  getJobsDashboard(filter: any, condition: any) {
    return this.http.get<any[]>(`${this.bssURL}/billinggroups/jobs/`, { params: { filter: JSON.stringify(filter), condition: JSON.stringify(condition) } });
  }

}



// WEBPACK FOOTER //
// ./src/pages/M2XV2/m2x-v2-service.ts